import React from 'react';

const DeleteRequest = () => {

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <h2>Request a Complete Wipe of your acount.</h2>
      <p>Contact us at <a href="mailto:support@myschedulepal.com">support@myschedulepal.com</a>.</p>
    </div>
  );
};

export default DeleteRequest;
